export class Role {
  constructor({
        id= null,      
        roleName= ``, 
        resources=[{resourceType:'',functions:[''],scopes:['']}],
        childRoles= ``,
        description= ``
    } = {}) {
    this.id = id;
    this.roleName = roleName;
    this.resources = resources;
    this.childRoles = childRoles;
    this.description = description;
  }
}
export function newEntity() {
  return new Role();
}
export function gridFields() {
  return Object.freeze([
      {
        key: 'roleName',
        label: 'lbl.role.name',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'description',
        label: 'lbl.role.description',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'resources',
        label: 'lbl.role.resources',
        sortable: true,
        form: {
          type: 'detailTable'
        }
      },
      {
        key: 'resource',
        label: 'lbl.role.resources',
        notInTable: true,
        form: {
          type: 'select',
          options: [
            { value: 'equipment', text: 'equipment' },
            { value: 'location', text: 'location' },
            { value: 'notification', text: 'notification' },
            { value: 'user', text: 'user' },
            { value: 'language', text: 'language' }
          ]
        }
      },
      {
        key: 'resources.scopes',
        label: 'lbl.role.scope',
        notInTable: true,
        form: {
          type: 'select'
        },
      },
      {
        key: 'resources.functions',
        label: '功能',
        notInTable: true,
        form: {
          type: 'select'
        },
      },
      // {
      //   key: 'description',
      //   label: 'lbl.basic.description',
      //   sortable: true,
      //   form: {
      //     type: 'input'
      //   }
      // }      
  ]);
}
export const fields = Object.freeze(Object.keys(new Role()).map(i => 'entity.' + i));

export const filterFields = [
  'filter.nameFilter'
];

export const filter = {
  'nameFilter': ""
};

// export const fields = [
//   'entity.id',
//   'entity.name',
//   'entity.resources'
// ]